import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Redirect, RouteComponentProps } from "react-router";
import { Link } from "react-router-dom";
import { useAuth } from "../../../services/Security/auth";
import { selectIsAuthenticated } from "../../../services/session/selectors";
import LoginForm from "../components/LoginForm";
import LoginLayout from "../components/LoginLayout";

const LoginPage = (props: RouteComponentProps) => {
	const { t } = useTranslation();
	const auth = useAuth();
	const isAuthenticated = useSelector(selectIsAuthenticated);

	useEffect(() => {
		checkLogin();
	}, []);

	const checkLogin = async () => {
		if (!isAuthenticated) {
			await auth.checkLogin();
		}
	};

	if (isAuthenticated) {
		return <Redirect to="/" />;
	}

	return (
		<LoginLayout>
			<LoginForm location={props.location} />
			<p className="login-contact-link">
				{t("modules.security.field.no_account.title")}{" "}
				<Link to="/register">{t("modules.security.action.create_an_account.title")}</Link>
			</p>
		</LoginLayout>
	);
};

export default LoginPage;
